/**
 * Returns the first valid address found from a list of subscriptions.
 * @param {Array} subscriptions
 */
export const getFirstAddressFromSubscriptions = (subscriptions) => {
  const firstSubWithAddress = subscriptions?.filter(
    (sub) => sub.shippingAddress || sub.activeBox?.shippingAddress
  )?.[0];

  return (
    firstSubWithAddress?.shippingAddress ||
    firstSubWithAddress?.activeBox?.shippingAddress ||
    null
  );
};
